
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GroupIcon from '@mui/icons-material/Group';
import TtkList from './TtkList';
const BrassBandTTK = ({ data }) => {
    return (
        <>

            <div className='row'>
                <div className='col-md-12'>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<span>{data?.workingSince?.map((item, index) => { return <span key={index}>{item.value}</span> })}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of Services :</b>&nbsp;<span>{data?.areaOfWork?.map((item, index) => { return <><i className='fa fa-check text-success' /><span key={index}>{item.value} </span></> })}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><GroupIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Number of Band-Member :</b>&nbsp;<span> {data?.bandmember}</span></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price (Wedding Band) :</b>&nbsp;<span>&#8377;{data?.charges}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Offered :</b>&nbsp;<TtkList data={data?.serviceOffered} /></p>
                        </div>
                        {/* <div className='col-md-4'>
                            <p><LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>At places we worked :</b>&nbsp;<TtkList data={data?.atplacedworked} /></p>
                        </div> */}
                    </div>

                </div>
            </div>

        </>

    )
}

export default BrassBandTTK